const sageGarden = {
    id: "sage-garden",
    name: "Sage Garden",
    ornament: "floral",
    radius: "soft",
    fonts: {
        display: "Cormorant Garamond",
        heading: "Fraunces",
        body: "Libre Baskerville",
    },
    colors: {
        bg: "#f4f1ea",
        bgAlt: "#e8e2d6",
        surface: "rgba(255,252,246,0.92)",
        primary: "#3e5344",
        primaryHover: "#2e3e32",
        accent: "#c4a484",
        accentSoft: "#e8d6c4",
        rose: "#c98b84",
        roseDeep: "#a86660",
        leaf: "#6d8f71",
        text: "#243028",
        textMuted: "#5a6b62",
        border: "#d8d0c2",
        buttonText: "#f7f4ee",
    },
};

const midnightVelvet = {
    id: "midnight-velvet",
    name: "Midnight Velvet",
    ornament: "floral",
    radius: "soft",
    fonts: {
        display: "Great Vibes",
        heading: "Cinzel",
        body: "Newsreader",
    },
    colors: {
        bg: "#1c1218",
        bgAlt: "#281820",
        surface: "rgba(42,28,36,0.92)",
        primary: "#f3e6d0",
        primaryHover: "#fff8ee",
        accent: "#d4b483",
        accentSoft: "#3d2c26",
        rose: "#c48996",
        roseDeep: "#e4b7c0",
        leaf: "#9aab86",
        text: "#f6efe6",
        textMuted: "#cbbba8",
        border: "#5c4638",
        buttonText: "#1c1218",
    },
};

const desertDune = {
    id: "desert-dune",
    name: "Desert Dune",
    ornament: "geometric",
    radius: "sharp",
    fonts: {
        display: "Italiana",
        heading: "Outfit",
        body: "Outfit",
    },
    colors: {
        bg: "#f3e6d4",
        bgAlt: "#e7d5bc",
        surface: "rgba(255,248,240,0.92)",
        primary: "#8c3d2b",
        primaryHover: "#6f2f22",
        accent: "#c47a45",
        accentSoft: "#f0d2b0",
        rose: "#e0b08a",
        roseDeep: "#7a4a32",
        leaf: "#a68462",
        text: "#3a2a22",
        textMuted: "#6a5548",
        border: "#e0cbb4",
        buttonText: "#fffaf6",
    },
};

const coastalLinen = {
    id: "coastal-linen",
    name: "Coastal Linen",
    ornament: "linear",
    radius: "round",
    fonts: {
        display: "Cormorant Garamond",
        heading: "Josefin Sans",
        body: "Outfit",
    },
    colors: {
        bg: "#f3f7f6",
        bgAlt: "#e5efed",
        surface: "rgba(255,255,255,0.92)",
        primary: "#1f3d4d",
        primaryHover: "#152e3b",
        accent: "#7eb8b3",
        accentSoft: "#d5ece9",
        rose: "#d7ebe8",
        roseDeep: "#2f6561",
        leaf: "#3d6b66",
        text: "#163038",
        textMuted: "#547076",
        border: "#c9ddda",
        buttonText: "#f7fbfb",
    },
};

const naturalEvening = [sageGarden, midnightVelvet, desertDune, coastalLinen];

export default naturalEvening;
